import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import {
    FaCube,
    FaDraftingCompass,
    FaFlask,
} from "react-icons/fa";

import {
    GiMeshNetwork,
    Gi3dHammer,
    GiAtomicSlashes,
} from "react-icons/gi";

import "../Style/ServiceSection.css";
import { myCustomTheme } from "../Theme";

const ServiceSection = () => {
    const theme = myCustomTheme;

    // ✅ OPEN ANIMATION
    useEffect(() => {
        const section = document.querySelector(".service-section");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("show");
                    }
                });
            },
            { threshold: 0.2 }
        );

        if (section) {
            observer.observe(section);
        }

        return () => {
            if (section) {
                observer.unobserve(section);
            }
        };
    }, []);

    const services = useSelector(
        (state) => state?.service?.services || []
    );

    const icons = {
        prototype: <GiMeshNetwork />,
        additive: <Gi3dHammer />,
        custom: <FaCube />,
        cad: <FaDraftingCompass />,
        batch: <GiAtomicSlashes />,
        material: <FaFlask />,
    };

    return (
        <section
            className="service-section"
            style={{
                background: theme.colors.bg_primary,
                fontFamily: theme.typography.text_font,
            }}
        >
            <div className="service-overlay"></div>

            <div
                className="service-container"
                style={{
                    maxWidth: theme.spacing.container_max,
                }}
            >
                {/* TOP */}
                <div className="service-top-layout">
                    <div className="service-top-cards">
                        {services.slice(0, 2).map((item) => (
                            <div
                                key={item.id}
                                className="service-card"
                                style={{
                                    border: `1px solid ${theme.colors.icon_border}`,
                                    borderRadius: theme.spacing.border_radius,
                                    boxShadow: theme.shadows.neumorphic,
                                }}
                            >
                                <div
                                    className="service-icon"
                                    style={{
                                        color: theme.colors.icon_color,
                                        fontSize: theme.fontSize?.icon || "clamp(40px, 4vw, 60px)",
                                    }}
                                >
                                    {icons[item.icon]}
                                </div>

                                <h3
                                    style={{
                                        color: theme.colors.heading,
                                        fontSize: theme.fontSize?.heading_small || "clamp(20px, 2vw, 28px)",
                                    }}
                                >
                                    {item.title}
                                </h3>

                                <p
                                    style={{
                                        fontSize: theme.fontSize?.text || "clamp(14px, 1.2vw, 16px)",
                                    }}
                                >
                                    {item.description}
                                </p>
                            </div>
                        ))}
                    </div>

                    <div className="service-content">
                        <span
                            style={{
                                color: "#ff9f1c",
                                fontWeight: "600",
                                fontSize: theme.fontSize?.subtitle || "20px",
                            }}
                        >
                            WHAT WE DO
                        </span>

                        <h1
                            style={{
                                color: theme.colors.heading,
                                fontSize: theme.fontSize?.heading || "clamp(32px, 4vw, 61px)",
                            }}
                        >
                            3D Printing Solutions for Your Business
                        </h1>

                        <p
                            style={{
                                fontSize: theme.fontSize?.text || "clamp(14px, 1.2vw, 17px)",
                            }}
                        >
                            Transform your ideas into reality with precision 3D printing solutions designed for speed, quality, and innovation.
                        </p>
                    </div>
                </div>

                {/* BOTTOM */}
                <div className="service-bottom-cards">
                    {services.slice(2, 6).map((item) => (
                        <div
                            key={item.id}
                            className="service-card"
                            style={{
                                background: theme.colors.bg_secondary,
                                border: `1px solid ${theme.colors.icon_border}`,
                                borderRadius: theme.spacing.border_radius,
                                boxShadow: theme.shadows.neumorphic,
                            }}
                        >
                            <div
                                className="service-icon"
                                style={{
                                    color: theme.colors.icon_color,
                                    fontSize: theme.fontSize?.icon || "clamp(40px, 4vw, 60px)",
                                }}
                            >
                                {icons[item.icon]}
                            </div>

                            <h3
                                style={{
                                    color: theme.colors.heading,
                                    fontSize: theme.fontSize?.heading_small || "clamp(20px, 2vw, 28px)",
                                }}
                            >
                                {item.title}
                            </h3>

                            <p
                                style={{
                                    fontSize: theme.fontSize?.text || "clamp(14px, 1.2vw, 16px)",
                                }}
                            >
                                {item.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ServiceSection;